import { ADDRESS_PROVIDER_V310 } from "@gearbox-protocol/sdk";
import {
  Address,
  createPublicClient,
  http,
  type PublicClient,
  type Transport,
} from "viem";
import { mainnet } from "viem/chains";

export class ClientConfig {
  static #instance: ClientConfig;
  public readonly rpcUrl: string;
  public readonly addressProvider: Address;
  protected publicClient: PublicClient<Transport, typeof mainnet>;

  protected constructor(rpcUrlChain?: string) {
    const { rpcUrl: envRpcUrl } = this.getEnvironmentConfig();
    const rpcUrl = rpcUrlChain || envRpcUrl;

    if (!rpcUrl) {
      throw new Error(
        "VITE_RPC_URL or VITE_DRPC_KEY not found in environment variables",
      );
    }

    this.rpcUrl = rpcUrl;
    this.addressProvider = ADDRESS_PROVIDER_V310 as Address;

    this.publicClient = createPublicClient({
      chain: mainnet,
      batch: {
        multicall: true,
      },
      transport: http(rpcUrl, {
        retryCount: 3,
        retryDelay: 1000,
        timeout: 10000,
      }),
    });
  }

  private getEnvironmentConfig() {
    const publicRpcUrl = import.meta.env.VITE_RPC_URL;
    const drpcKey = import.meta.env.VITE_DRPC_KEY;

    // Use DRPC if key is provided, otherwise use direct RPC URL
    const rpcUrl = drpcKey
      ? `https://lb.drpc.org/ogrpc?network=ethereum&dkey=${drpcKey}`
      : publicRpcUrl;

    const addressProvider = ADDRESS_PROVIDER_V310;

    return { publicRpcUrl, rpcUrl, addressProvider };
  }

  public static getInstance(): ClientConfig {
    if (!ClientConfig.#instance) {
      ClientConfig.#instance = new ClientConfig();
    }
    return ClientConfig.#instance;
  }

  get client() {
    return this.publicClient;
  }
}
